import RouteNames from "@/entities/RouteNames";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import Roles from "@/entities/Roles";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";

const DocumentsAdminAll = () =>
  import("@/views/manage/documents/admin/DocumentsAdminAll.vue").then(
    (m) => m.default
  );
const DocumentsAdminProjects = () =>
  import("@/views/manage/documents/admin/DocumentsAdminProjects.vue").then(
    (m) => m.default
  );
const DocumentsAdminContractors = () =>
  import("@/views/manage/documents/admin/DocumentsAdminContractors.vue").then(
    (m) => m.default
  );
const DocumentsAdminManagers = () =>
  import("@/views/manage/documents/admin/DocumentsAdminManagers.vue").then(
    (m) => m.default
  );
const DocumentsManagerAll = () =>
  import("@/views/manage/documents/manager/DocumentsManagerAll.vue").then(
    (m) => m.default
  );
const DocumentsManagerProjects = () =>
  import("@/views/manage/documents/manager/DocumentsManagerProjects.vue").then(
    (m) => m.default
  );
const DocumentsManagerContractors = () =>
  import(
    "@/views/manage/documents/manager/DocumentsManagerContractors.vue"
  ).then((m) => m.default);

const getDocumentsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/documents",
    component: RouteWrapper,
    children: [
      {
        path: "all",
        name: RouteNames.DOCUMENTS_ADMIN_ALL,
        component: DocumentsAdminAll,
        meta: {
          title: "All Documents",
          roles: [Roles.ADMIN],
          breadcrumb: {
            title: BreadcrumbsTitles.ALL_DOCUMENTS,
            icon: NavigationIcons.ALL_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_ADMIN_ALL,
            prefix: RouteSectionsPrefixes.ALL_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "projects",
        name: RouteNames.DOCUMENTS_ADMIN_PROJECTS,
        component: DocumentsAdminProjects,
        meta: {
          title: "Projects Documents",
          roles: [Roles.ADMIN],
          breadcrumb: {
            title: BreadcrumbsTitles.PROJECTS_DOCUMENTS,
            icon: NavigationIcons.PROJECTS_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_ADMIN_PROJECTS,
            prefix: RouteSectionsPrefixes.PROJECTS_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "contractors",
        name: RouteNames.DOCUMENTS_ADMIN_CONTRACTORS,
        component: DocumentsAdminContractors,
        meta: {
          title: "Contractors Documents",
          requiresAuth: true,
          roles: [Roles.ADMIN , Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.CONTRACTORS_DOCUMENTS,
            icon: NavigationIcons.CONTRACTORS_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_ADMIN_CONTRACTORS,
            prefix: RouteSectionsPrefixes.CONTRACTORS_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "managers",
        name: RouteNames.DOCUMENTS_ADMIN_MANAGERS,
        component: DocumentsAdminManagers,
        meta: {
          title: "Managers Documents",
          requiresAuth: true,
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.MANAGERS_DOCUMENTS,
            icon: NavigationIcons.MANAGER,
            routeName: RouteNames.DOCUMENTS_ADMIN_MANAGERS,
            prefix: RouteSectionsPrefixes.MANAGERS_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "manager/all",
        name: RouteNames.DOCUMENTS_MANAGER_ALL,
        component: DocumentsManagerAll,
        meta: {
          title: "Documents",
          requiresAuth: true,
          roles: [Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.ALL_DOCUMENTS,
            icon: NavigationIcons.ALL_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_MANAGER_ALL,
            prefix: RouteSectionsPrefixes.ALL_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "manager/projects",
        name: RouteNames.DOCUMENTS_MANAGER_PROJECTS,
        component: DocumentsManagerProjects,
        meta: {
          title: "Documents",
          requiresAuth: true,
          roles: [Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.PROJECTS_DOCUMENTS,
            icon: NavigationIcons.PROJECTS_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_MANAGER_PROJECTS,
            prefix: RouteSectionsPrefixes.PROJECTS_DOCUMENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "manager/contractors",
        name: RouteNames.DOCUMENTS_MANAGER_CONTRACTORS,
        component: DocumentsManagerContractors,
        meta: {
          title: "Documents",
          requiresAuth: true,
          roles: [Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.CONTRACTORS_DOCUMENTS,
            icon: NavigationIcons.CONTRACTORS_DOCUMENTS,
            routeName: RouteNames.DOCUMENTS_MANAGER_CONTRACTORS,
            prefix: RouteSectionsPrefixes.CONTRACTORS_DOCUMENTS,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

export { getDocumentsRoutes };
